/*
 * Footer behaviour (sections/footer.liquid)
 *  - <footer-accordions>: link columns are collapsible accordions on phones and always open on larger screens.
 *  - [data-footer-top]: smooth "back to top" button.
 */
if (!customElements.get('footer-accordions')) {
  customElements.define(
    'footer-accordions',
    class FooterAccordions extends HTMLElement {
      connectedCallback() {
        this.mediaQuery = window.matchMedia('(min-width: 750px)');
        this.onChange = () => this.sync();
        this.onClick = (event) => {
          const summary = event.target.closest('summary');
          // on larger screens the columns are static, so don't let the summary toggle them
          if (summary && this.mediaQuery.matches) event.preventDefault();
        };

        if (this.mediaQuery.addEventListener) {
          this.mediaQuery.addEventListener('change', this.onChange);
        } else {
          this.mediaQuery.addListener(this.onChange);
        }
        this.addEventListener('click', this.onClick);
        this.sync();
      }

      disconnectedCallback() {
        if (!this.mediaQuery) return;
        if (this.mediaQuery.removeEventListener) {
          this.mediaQuery.removeEventListener('change', this.onChange);
        } else {
          this.mediaQuery.removeListener(this.onChange);
        }
        this.removeEventListener('click', this.onClick);
      }

      sync() {
        const isLarge = this.mediaQuery.matches;
        this.querySelectorAll('details.footer-accordion').forEach((details) => {
          details.open = isLarge;
        });
      }
    }
  );
}

if (!window.__footerTopBound) {
  window.__footerTopBound = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-footer-top]');
    if (!button) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    document.getElementById('MainContent')?.focus({ preventScroll: true });
  });
}
